import { useStationPage } from "../components/StationLayout";
import StreamPlayer from "../components/StreamPlayer";

/**
 * The station's landing tab: its own blurb, the live player, and the feed
 * links. The inline player lives here and only here — on every other page
 * the site-wide dock takes over once playback starts (see PlayerDock).
 */
const AboutPage = () => {
  const { stationSlug, status } = useStationPage();

  return (
    <>
      {status.description && (
        <p className="station__blurb">{status.description}</p>
      )}

      <StreamPlayer />

      {/* No podcast.rss link: the feed is logged-in-only for now, and a
          public link to permanent audio URLs was a crawler magnet. */}
      <nav className="station__links mono" aria-label="Station feeds">
        {Boolean(status.stream_url) && (
          <a href={`/${stationSlug}/listen.mp3`}>listen.mp3</a>
        )}
        <a href={`/${stationSlug}/schedule.ics`}>schedule.ics</a>
      </nav>
    </>
  );
};

export default AboutPage;
